import { getRealJsonData } from "./longNumberToString"
export const jwtGetInfo = (token: string) => {
  const str = token.split(".")
  const obj = JSON.parse(
    decodeURIComponent(escape(window.atob(str[1].replace(/-/g, "+").replace(/_/g, "/"))))
  )
  return getRealJsonData(obj.su)
}
